/* nani pua: おすすめサイズ診断 (size recommender) v2 */
(function () {
  var CSS = '' +
    '.size-rec{background:#f5f1ec;border-radius:8px;padding:18px 18px 16px;margin:0 0 24px;font-size:14px;line-height:1.6;color:#1a1a1a}' +
    '.size-rec__title{font-weight:bold;font-size:15px;margin:0 0 10px}' +
    '.size-rec__tabs{display:flex;gap:0;margin:0 0 14px;border-bottom:1px solid #d9d2c8}' +
    '.size-rec__tab{flex:1;text-align:center;padding:8px 2px;font-size:13px;color:#7a6f66;border-bottom:2px solid transparent;margin-bottom:-1px;background:none;cursor:pointer}' +
    '.size-rec__tab.is-active{color:#1a1a1a;font-weight:bold;border-bottom-color:#522f15}' +
    '.size-rec__row{display:flex;gap:12px;margin:0 0 12px}' +
    '.size-rec__field{flex:1;min-width:0;display:block}' +
    '.size-rec__label{display:block;font-size:12px;color:#5c534c;margin:0 0 4px}' +
    '.size-rec__unit{position:relative;display:block}' +
    '.size-rec__unit input{width:100%;height:44px;padding:0 36px 0 12px;font-size:16px;border:1px solid #cfc7bd;border-radius:4px;background:#fff;color:#1a1a1a;-moz-appearance:textfield}' +
    '.size-rec__unit input::-webkit-outer-spin-button,.size-rec__unit input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}' +
    '.size-rec__unit input:focus{outline:none;border-color:#522f15}' +
    '.size-rec__unit span{position:absolute;right:12px;top:50%;transform:translateY(-50%);font-size:13px;color:#7a6f66;pointer-events:none}' +
    '.size-rec__fits{display:flex;gap:8px}' +
    '.size-rec__fit{flex:1;text-align:center;height:38px;border:1px solid #cfc7bd;border-radius:19px;background:#fff;font-size:13px;color:#1a1a1a;cursor:pointer}' +
    '.size-rec__fit.is-active{background:#522f15;border-color:#522f15;color:#fff}' +
    '.size-rec__hint{font-size:12px;color:#7a6f66;margin:6px 0 0}' +
    '.size-rec__result{margin:14px 0 0;padding:14px 16px;background:#fff;border-radius:6px}' +
    '.size-rec__result[hidden]{display:none}' +
    '.size-rec__answer{margin:0}' +
    '.size-rec__size{font-size:22px;font-weight:bold;color:#522f15;margin:0 2px}' +
    '.size-rec__detail{margin:4px 0 0;font-size:13px;color:#5c534c}' +
    '.size-rec__note{margin:6px 0 0;font-size:12px;color:#e2542f}' +
    '.size-rec__list{display:flex;gap:8px;margin:10px 0 0;padding:0;list-style:none}' +
    '.size-rec__list li{flex:1;text-align:center;padding:6px 2px;border:1px solid #e3ddd5;border-radius:4px;font-size:12px;color:#5c534c;margin:0}' +
    '.size-rec__list li::before{display:none}' +
    '.size-rec__list li.is-best{border-color:#522f15;color:#1a1a1a;font-weight:bold}' +
    '.size-rec__list b{display:block;font-size:14px}';

  var FIT_TEXT = {
    tight: '体にほどよく沿う、すっきりとした着心地です',
    regular: 'ほどよいゆとりのある着心地です',
    loose: 'ゆとりのあるリラックスした着心地です'
  };
  var FIT_TEXT_BOTTOM = {
    tight: 'ウエストがしっかりフィットする履き心地です',
    regular: 'ほどよいゆとりのある履き心地です',
    loose: 'ウエストにゆとりのある楽な履き心地です'
  };

  function injectCss() {
    if (document.getElementById('size-rec-style')) return;
    var s = document.createElement('style');
    s.id = 'size-rec-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function num(v) {
    var n = parseFloat(String(v).replace(/[０-９．]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); }));
    return isNaN(n) ? null : n;
  }

  // 体型の目安（身長・体重から推定）
  function body(mode, h, w) {
    if (mode === 'mens') return { bust: 92 + 0.85 * (w - 65) - 0.2 * (h - 170) };
    return { bust: 83 + 1.0 * (w - 52) - 0.2 * (h - 158), waist: 64 + 1.0 * (w - 52) - 0.15 * (h - 158) };
  }

  // サイズ表（ページ本文の表）からサイズを読み取る
  function fromTable(box, cfg) {
    var tables = Array.prototype.slice.call(box.querySelectorAll('table'));
    if (!tables.length) return null;
    var table = tables[0];
    if (tables.length > 1 && cfg.sku) {
      tables.forEach(function (t) {
        var cap = t.previousElementSibling;
        if (cap && cap.textContent.toUpperCase().indexOf(cfg.sku) >= 0) table = t;
      });
    }
    var rows = Array.prototype.slice.call(table.querySelectorAll('tr')).map(function (tr) {
      return Array.prototype.slice.call(tr.children).map(function (c) { return c.textContent.trim(); });
    });
    var key = cfg.mode === 'bottom' ? 'ウエスト' : '身幅';
    var wi = -1, li = -1, sizes = [];
    rows.forEach(function (r) {
      if (wi < 0) {
        var a = r.indexOf(key), b = -1;
        ['着丈', '総丈', '身丈'].forEach(function (k) { if (b < 0) b = r.indexOf(k); });
        if (a > 0) { wi = a; li = b; }
        return;
      }
      var w = num(r[wi]);
      if (r[0] && w !== null) sizes.push([r[0], w, li > 0 ? num(r[li]) : null]);
    });
    if (sizes.length < 2) return null;
    var out = { mode: cfg.mode || 'tee', sizes: sizes };
    if (out.mode === 'tee') {
      var up = function (w) { return Math.round(1.5 * w * 2 - 77); };
      var reg = sizes.slice(0, -1).map(function (s) { return up(s[1]); });
      var last = up(sizes[sizes.length - 1][1]);
      out.limits = {
        tight: reg.map(function (v) { return v + 4; }).concat([last + 9]),
        regular: reg.concat([last + 5]),
        loose: reg.map(function (v) { return v - 5; }).concat([last])
      };
    } else {
      var names = sizes.map(function (s) { return s[0]; });
      var bi = names.indexOf('M'); if (bi < 0) bi = Math.floor((sizes.length - 1) / 2);
      var base = out.mode === 'mens' ? 92 : (out.mode === 'bottom' ? 64 : 83);
      // デザイン上のゆとり（Mサイズが標準体型に少し余裕をもって合うように）
      out.offset = 2 * sizes[bi][1] - base - (out.mode === 'bottom' ? 0 : 2);
    }
    return out;
  }

  function sizeInfo(cfg, name) {
    for (var i = 0; i < cfg.sizes.length; i++) if (cfg.sizes[i][0] === name) return cfg.sizes[i];
    return null;
  }

  function build(cfg) {
    var bottom = cfg.mode === 'bottom';
    var garmentWord = cfg.mode === 'tee' ? 'Tシャツ' : (bottom ? 'スカート・パンツ' : '服');
    var root = document.createElement('div');
    root.className = 'size-rec';
    root.innerHTML =
      '<p class="size-rec__title">あなたにおすすめのサイズ</p>' +
      '<div class="size-rec__tabs" role="tablist">' +
        '<button type="button" class="size-rec__tab is-active" data-tab="body">かんたん診断</button>' +
        (bottom ? '<button type="button" class="size-rec__tab" data-tab="waist">ウエスト</button>' : '') +
        '<button type="button" class="size-rec__tab" data-tab="garment">' + (bottom ? '手持ちの服' : '手持ちの服と比べる') + '</button>' +
      '</div>' +
      '<div data-panel="body">' +
        '<div class="size-rec__row">' +
          '<label class="size-rec__field"><span class="size-rec__label">身長</span><span class="size-rec__unit"><input type="number" inputmode="decimal" min="120" max="200" data-in="height"><span>cm</span></span></label>' +
          '<label class="size-rec__field"><span class="size-rec__label">体重</span><span class="size-rec__unit"><input type="number" inputmode="decimal" min="25" max="150" data-in="weight"><span>kg</span></span></label>' +
        '</div>' +
      '</div>' +
      (bottom ?
      '<div data-panel="waist" hidden>' +
        '<label class="size-rec__field" style="margin:0 0 12px"><span class="size-rec__label">ウエスト（お腹まわり）</span><span class="size-rec__unit"><input type="number" inputmode="decimal" min="40" max="130" data-in="bwaist"><span>cm</span></span></label>' +
      '</div>' : '') +
      '<div data-panel="fit">' +
        '<span class="size-rec__label">好みのフィット感</span>' +
        '<div class="size-rec__fits">' +
          '<button type="button" class="size-rec__fit" data-fit="tight">ぴったり</button>' +
          '<button type="button" class="size-rec__fit is-active" data-fit="regular">ふつう</button>' +
          '<button type="button" class="size-rec__fit" data-fit="loose">ゆったり</button>' +
        '</div>' +
      '</div>' +
      '<div data-panel="garment" hidden>' +
        '<label class="size-rec__field"><span class="size-rec__label">お手持ちの' + garmentWord + 'の' + (bottom ? 'ウエスト（平置き）' : '身幅') + '</span><span class="size-rec__unit"><input type="number" inputmode="decimal" step="0.5" min="15" max="90" data-in="width"><span>cm</span></span></label>' +
        '<p class="size-rec__hint">' + (bottom
          ? 'サイズ感が気に入っているスカートやパンツを平らに置き、ウエストの端から端までを測ってください（ゴムは伸ばさずに）。'
          : 'サイズ感が気に入っている' + garmentWord + 'を平らに置き、両脇の下の端から端までを測ってください。') + '</p>' +
      '</div>' +
      '<div class="size-rec__result" hidden aria-live="polite"></div>';

    var state = { tab: 'body', fit: 'regular' };
    var result = root.querySelector('.size-rec__result');
    var names = cfg.sizes.map(function (s) { return s[0]; });
    var n = names.length;

    function q(sel) { return root.querySelector(sel); }

    function showSize(cand, best, notes) {
      var info = sizeInfo(cfg, best);
      var label = cand.length > 1
        ? '<span class="size-rec__size">' + cand.join('〜') + '</span>（迷ったら<span class="size-rec__size">' + best + '</span>）'
        : '<span class="size-rec__size">' + best + '</span>';
      var html = '<p class="size-rec__answer">あなたにおすすめのサイズは ' + label + ' です</p>';
      if (info) {
        var d = bottom ? 'ウエスト' + info[1] + 'cm（平置き）' : '身幅' + info[1] + 'cm';
        if (info[2]) d += (bottom ? '・総丈' : '・着丈') + info[2] + 'cm';
        html += '<p class="size-rec__detail">' + d + '／' + (bottom ? FIT_TEXT_BOTTOM : FIT_TEXT)[state.fit] + '</p>';
      }
      for (var i = 0; i < notes.length; i++) html += '<p class="size-rec__note">' + notes[i] + '</p>';
      result.innerHTML = html;
      result.hidden = false;
    }

    // Tシャツ（従来の判定表）
    function teeJudge(h, w) {
      var lim = cfg.limits[state.fit];
      var wr = Math.round(w);
      var idx = n - 1;
      for (var i = 0; i < lim.length - 1 && i < n - 1; i++) { if (wr <= lim[i]) { idx = i; break; } }
      var notes = [], cand = [names[idx]], best = names[idx];
      for (var j = 0; j < n - 1 && j < lim.length - 1; j++) {
        if (Math.abs(w - (lim[j] + 0.5)) <= 1) {
          cand = [names[j], names[j + 1]];
          best = state.fit === 'tight' ? names[j] : names[j + 1];
          break;
        }
      }
      if (best === names[n - 1] && cand.length === 1 && w > lim[lim.length - 1]) notes.push('ぴったりめの着用感になります');
      if (h >= 165 && best !== names[n - 1]) notes.push('身長が高めの方は、丈が気になる場合ワンサイズ上もおすすめです');
      showSize(cand, best, notes);
    }

    var ADJ = { tight: -4, regular: 0, loose: 4 };

    // トップス・ワンピース・メンズ：推定バスト＋デザインのゆとりで判定
    function topJudge(bust, h) {
      var need = bust + cfg.offset + ADJ[state.fit];
      var idx = -1;
      for (var i = 0; i < n; i++) { if (2 * cfg.sizes[i][1] >= need) { idx = i; break; } }
      var notes = [];
      if (idx < 0) {
        idx = n - 1;
        notes.push('ぴったりめの着用感になります');
        return showSize([names[idx]], names[idx], notes);
      }
      var cand = [names[idx]], best = names[idx];
      if (idx < n - 1 && 2 * cfg.sizes[idx][1] - need < 1.5) {
        cand = [names[idx], names[idx + 1]];
        best = state.fit === 'tight' ? names[idx] : names[idx + 1];
      }
      if (h >= 165 && cfg.mode !== 'mens' && best !== names[n - 1]) notes.push('身長が高めの方は、丈が気になる場合ワンサイズ上もおすすめです');
      showSize(cand, best, notes);
    }

    // スカート・パンツ：ウエストで判定（ゴムの伸びを考慮して各サイズの目安ウエストと比較）
    function bottomJudge(bw) {
      var v = bw + ADJ[state.fit] * 0.75;
      var T = cfg.sizes.map(function (s) { return 2 * s[1] - cfg.offset; });
      var idx = 0;
      for (var i = 0; i < n; i++) { if (Math.abs(T[i] - v) <= Math.abs(T[idx] - v)) idx = i; }
      var cand = [names[idx]], best = names[idx], notes = [];
      var nb = v > T[idx] ? idx + 1 : idx - 1;
      if (nb >= 0 && nb < n) {
        var mid = (T[idx] + T[nb]) / 2;
        if (Math.abs(v - mid) < 1) {
          var lo = Math.min(idx, nb), hi = Math.max(idx, nb);
          cand = [names[lo], names[hi]];
          best = state.fit === 'tight' ? names[lo] : names[hi];
        }
      }
      if (v > T[n - 1] + 6) notes.push('ウエストがきつめに感じる場合があります');
      if (v < T[0] - 8) notes.push('ウエストがゆるめに感じる場合があります（ゴムで調整できます）');
      showSize(cand, best, notes);
    }

    function calcBody() {
      var h = num(q('[data-in="height"]').value);
      var w = num(q('[data-in="weight"]').value);
      if (h === null || w === null || h < 120 || h > 200 || w < 25 || w > 150) { result.hidden = true; return; }
      if (cfg.mode === 'tee') return teeJudge(h, w);
      var b = body(cfg.mode, h, w);
      if (bottom) return bottomJudge(b.waist);
      topJudge(b.bust, h);
    }

    function calcWaist() {
      var bw = num(q('[data-in="bwaist"]').value);
      if (bw === null || bw < 40 || bw > 130) { result.hidden = true; return; }
      bottomJudge(bw);
    }

    function calcGarment() {
      var g = num(q('[data-in="width"]').value);
      if (g === null || g < 15 || g > 90) { result.hidden = true; return; }
      var bestI = 0, bestD = Infinity;
      cfg.sizes.forEach(function (s, i) {
        var d = Math.abs(s[1] - g);
        if (d <= bestD) { bestD = d; bestI = i; }
      });
      var best = cfg.sizes[bestI];
      var list = cfg.sizes.map(function (s, i) {
        var diff = Math.round((s[1] - g) * 10) / 10;
        var t = diff === 0 ? '±0cm' : (diff > 0 ? '+' + diff : '−' + Math.abs(diff)) + 'cm';
        return '<li' + (i === bestI ? ' class="is-best"' : '') + '><b>' + s[0] + '</b>' + s[1] + 'cm（' + t + '）</li>';
      }).join('');
      result.innerHTML =
        '<p class="size-rec__answer">お手持ちの' + garmentWord + 'に一番近いのは <span class="size-rec__size">' + best[0] + '</span> です</p>' +
        '<ul class="size-rec__list">' + list + '</ul>' +
        '<p class="size-rec__detail">＋はお手持ちより大きく、−は小さくなります。</p>';
      result.hidden = false;
    }

    function calc() {
      if (state.tab === 'body') calcBody();
      else if (state.tab === 'waist') calcWaist();
      else calcGarment();
    }

    function showPanels() {
      root.querySelectorAll('[data-panel]').forEach(function (p) {
        var k = p.getAttribute('data-panel');
        p.hidden = k === 'fit' ? state.tab === 'garment' : k !== state.tab;
      });
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('.size-rec__tab');
      if (tab) {
        state.tab = tab.getAttribute('data-tab');
        root.querySelectorAll('.size-rec__tab').forEach(function (b) { b.classList.toggle('is-active', b === tab); });
        showPanels();
        calc();
        return;
      }
      var fit = e.target.closest('.size-rec__fit');
      if (fit) {
        state.fit = fit.getAttribute('data-fit');
        root.querySelectorAll('.size-rec__fit').forEach(function (b) { b.classList.toggle('is-active', b === fit); });
        calc();
      }
    });
    root.addEventListener('input', calc);
    showPanels();
    return root;
  }

  function init() {
    var configs = document.querySelectorAll('script.size-rec-config');
    if (!configs.length) return;
    injectCss();
    configs.forEach(function (el) {
      var conf;
      try { conf = JSON.parse(el.textContent); } catch (e) { return; }
      (conf.targets || []).forEach(function (id) {
        var box = document.getElementById(id);
        if (!box || box.querySelector('.size-rec')) return;
        var cfg = conf;
        if (conf.parse) { cfg = fromTable(box, conf); if (!cfg) return; }
        else if (!cfg.mode) cfg.mode = 'tee';
        var content = box.querySelector('.drawer__content, .popover__content');
        if (!content) return;
        content.insertBefore(build(cfg), content.firstChild);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();